import { render, staticRenderFns } from "./TowerLink.vue?vue&type=template&id=64889564&"
import script from "./TowerLink.vue?vue&type=script&lang=js&"
export * from "./TowerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports